import axios from 'axios';
import { setPrepayBilled } from './loads.action';

export const authService = {
  /** Create, Edit Load */

  createLoadService: (body) => axios.post('/loads', body, { auth: true }),

  createLoadTemplateService: (id, body) => axios.post(`/loads/fromTemplate/${id}`, body, { auth: true }),

  editLoadService: (body, id) => axios.patch(`/loads/${id}`, body, { auth: true }),

  cancelLoadService: (id) => axios.post(`/loads/${id}/cancel`, {}, { auth: true }),

  /** End */

  /** Get Loads */

  getLoadsByPayableService: (id) => axios.get(`/loads/payables/${id}`, { auth: true }),

  /** Edit Payables Tables */

  editOpenPayablesTable: (loadId, body, type) => {
    const path = type === 'payee' ? `/loads/${loadId}/payables/payee` : type === 'method' ? `/loads/${loadId}/payables/method` : `/loads/${loadId}/payables/term`;

    return axios.patch(path, body, { auth: true });
  },

  /** End */

  /** Batches */
  getBatches: (params) => axios.get(`/loads/payables/batch/all`, { auth: true, params }),

  createBatchService: (body) => axios.post(`/loads/payables/batch`, body, { auth: true }),

  editBatchTableService: (id, body) => axios.patch(`/batch/${id}`, body, { auth: true }),

  getLoadsPayableBatchesService: (id) => axios.get(`/loads/payables/batch/${id}`, { auth: true }),

  deleteLoadsPayableBatchesService: (id) => axios.delete(`/loads/payables/batch/${id}`, { auth: true }),

  moveLoadsPayableBatchesService: (id, body) => axios.patch(`/loads/payables/batch/${id}`, body, { auth: true }),

  removeLoadsPayableBatchesService: (id, body) => axios.patch(`/loads/payables/batch/${id}/remove`, body, { auth: true }),

  /** End */

  getLoadTotalsService: () => axios.get('/loads/totals', { auth: true }),

  getLoadsByStatusService: (params) => axios.get('/loads', { auth: true, params: { ...params } }),

  getCustomerLoadService: (id) => axios.get(`/loads/customer/${id}`, { auth: true }),

  getCarrierLoadService: (id, params) => axios.get(`/loads/carrier/${id}`, { auth: true, params: { ...params } }),

  getCarrierLastLoadService: (id) => axios.get(`/loads/carrier/${id}/lastLoads`, { auth: true }),

  getLoadByIdService: (id) => axios.get(`/loads/${id}`, { auth: true }),

  getReceivablesInfoService: (params) => axios.get(`/loads/receivables/accounting/totals`, {
    auth: true,
    params: { ...params },
  }),

  getReceivableCustomersForSelectService: (params) => axios.get(`/loads/receivables/customer/select`, {
    auth: true,
    params: { ...params },
  }),

  getPayableInfoService: (params) => axios.get(`/loads/payable/accounting/totals`, {
    auth: true,
    params: { ...params },
  }),

  setAsBadDebtService: (params) => axios.patch(`/loads/bill/badDebt`, params, { auth: true }),

  /** End */


  /** Load Transactions */

  getLoadTransactionsService: (id, params) => axios.get(`/loads/${id}/txns`, { auth: true, params: { ...params } }),

  getLoadCarrierTransactionsService: (id, params) => axios.get(`/loads/${id}/txns`, {
    auth: true,
    params: { ...params },
  }),

  createLoadTransactionsService: (id, date) => axios.post(`/loads/${id}/txns`, date, { auth: true }),

  editTransactionsService: (id, txnId, params) => axios.patch(`/loads/${id}/txns/${txnId}/pending`, params, { auth: true }),

  editLoadTransactionsService: (id, txnsId) => axios.patch(`/loads/${id}/txns/${txnsId}/void`, null, { auth: true }),

  deleteTransactionsService: (id, txnsId) => axios.delete(`/loads/${id}/txns/${txnsId}/delete`, { auth: true }),

  editTransactionsDescService: (id, body) => axios.patch(`/loads/txns/${id}`, body, { auth: true }),

  reverseTransactionService: (id) => axios.post(`/loads/${id}/reverseLPF`, null, { auth: true }),

  /** End */

  /** Load Payable */

  sendToPayableService: (id) => axios.post(`/loads/${id}/payables/send`, null, { auth: true }),

  appendPayableService: (id) => axios.patch(`/loads/${id}/payables/approve`, null, { auth: true }),

  sendToCarrierEmail: (loadId) => axios.get(`/carrier-pmts/remittance/${loadId}`, { auth: true }),

  /** End */

  /** Pasts */

  getPastPayableService: (id) => axios.get(`/loads/${id}/pastPayables`, { auth: true }),

  getPastBillService: (id) => axios.get(`/loads/${id}/pastBills`, { auth: true }),

  reBillService: (id) => axios.post(`/loads/${id}/billing/rebill`, null, { auth: true }),

  /** End */

  search: (name) => axios.get(`/customers/search`, { auth: true, params: { searchString: name, status: 'ACTIVE' } }),

  getLoadBYCustomers: (ids) => axios.get(`/loads/notes/customers`, { auth: true, params: { ids: ids } }),

  /** Payable Notes */

  createPayableNotesService: (loadId, body) => axios.post(`/loads/${loadId}/payables/note`, body, { auth: true }),

  editPayableNotesService: (loadId, noteId, body) => axios.patch(`/loads/${loadId}/payables/note/${noteId}`, body, { auth: true }),

  deletePayableNotesService: (loadId, noteId, body) => axios.patch(`/loads/${loadId}/payables/note/${noteId}/remove`, body, { auth: true }),

  /** End */

  /** Receivable Notes */

  getRecNotesService: (params) => axios.get(`/receivable-notes`, { auth: true, params: { ...params } }),

  createRecNotesService: (body) => axios.post(`/receivable-notes`, body, { auth: true }),

  editRecNotesService: (id, body) => axios.patch(`/receivable-notes/${id}`, body, { auth: true }),

  deleteRecNotesService: (id, body) => axios.delete(`/receivable-notes/${id}`, { auth: true }),

  /** End */

  uploadLoadListService: (file, id) => axios.post(`/loads/csv/import`, file, {
    auth: true,
    params: { customerId: id },
  }),

  /** Customer Order */

  createCustomerOrderService: (loadId, body) => axios.post(`/loads/${loadId}/customerOrderInfo`, body, { auth: true }),

  editCustomerOrderService: (loadId, id, body) => axios.patch(`/loads/${loadId}/customerOrderInfo/${id}`, body, { auth: true }),

  deleteCustomerOrderService: (loadId, id) => axios.delete(`/loads/${loadId}/customerOrderInfo/${id}`, { auth: true }),

  /** End */

  /** Grouped Loads */

  getBillingGroupsService: (params) => axios.get('/loadGroups', { auth: true, params: { ...params } }),

  getBillingGroupLoadsService: (id) => axios.get(`/loads/loadGroup/${id}/billing`, { auth: true }),

  getBillingPrepaidLoadsService: (params) => axios.get(`/loads/billing/customer/prepaid`, { auth: true,  params: { ...params }}),

  setPrepayBilled: (id, params) => axios.patch(`/loads/${id}/setPrepayBilled`, {},{ auth: true, params: { ...params }}),

  getGroupedLoadsService: (params) => axios.get('/loadGroups', { auth: true, params: { ...params } }),

  getGroupByIdService: (id) => axios.get(`/loadGroups/${id}`, { auth: true }),

  getGroupLoadsService: (id) => axios.get(`/loads/loadGroup/${id}`, { auth: true }),

  cancelGroupService: (id) => axios.post(`/loads/loadgroup/${id}/cancel`, null, { auth: true }),

  getGroupPayableLoadsService: (id) => axios.get(`/loads/loadGroup/${id}/invoice`, { auth: true }),

  getGroupLoadsTxnsService: (id) => axios.get(`/loads/loadGroup/${id}/txns`, { auth: true }),

  pauseGroupLoadBillingService: (id, pause) => axios.patch(`/loadGroups/${id}/readyForBilling`, {readyForBilling: pause}, { auth: true }),

  /** End */

  getCorporateTxnsService: (params) => axios.get(`/txns/corporate`, { auth: true, params: { ...params } }),

  getShortOverpaysService: (params) => axios.get(`/loads/short/Over/Pays`, { auth: true, params: { ...params } }),

  applyPayTo: (id, params) => axios.patch(`/loads/${id}/ShortOverPay`, params, { auth: true }),

};
